import axios from '@/axios';

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/property`;

const state = {
  isSubmitting: false,
  lastSubmissionResult: null,
  appointments: [],
};

const mutations = {
  SET_SUBMITTING(state, isSubmitting) {
    state.isSubmitting = isSubmitting;
  },
  SET_SUBMISSION_RESULT(state, result) {
    state.lastSubmissionResult = result;
  },
  ADD_APPOINTMENT(state, appointment) {
    state.appointments.unshift(appointment);
  },
  CLEAR_SUBMISSION_RESULT(state) {
    state.lastSubmissionResult = null;
  },
};

const actions = {
  async requestAppointment({ commit }, { propertyId, appointmentData }) {
    commit('SET_SUBMITTING', true);
    commit('CLEAR_SUBMISSION_RESULT');
    
    try {
      // Prepare the data according to the backend API format
      const payload = {
        fecha_cita: appointmentData.fecha_cita,
        nombre_visitante: appointmentData.nombre_visitante,
        telefono_visitante: appointmentData.telefono_visitante,
        email_visitante: appointmentData.email_visitante,
        mensaje_inicial: appointmentData.mensaje_inicial,
      };

      console.log('Sending appointment request:', {
        url: `${API_BASE}/${propertyId}/solicitar-cita/`,
        payload
      });

      const response = await axios.post(
        `${API_BASE}/${propertyId}/solicitar-cita/`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const result = {
        success: true,
        message: 'Solicitud de cita enviada exitosamente. El agente se pondrá en contacto contigo pronto.',
        data: response.data,
      };

      commit('SET_SUBMISSION_RESULT', result);
      commit('ADD_APPOINTMENT', {
        ...payload,
        propertyId,
        timestamp: new Date().toISOString(),
        status: 'pending',
        id: response.data?.id || Date.now(), // Fallback ID if not provided
      });

      return result;
    } catch (error) {
      console.error('Error requesting appointment:', error);
      
      // Handle different types of errors
      let errorMessage = 'Error al enviar la solicitud de cita';
      let fieldErrors = {};

      if (error.response) {
        // Server responded with error status
        const errorData = error.response.data;
        
        if (error.response.status === 400) {
          // Validation errors
          errorMessage = 'Por favor revisa los datos ingresados';
          
          // Map backend field errors to frontend field names
          if (errorData.nombre_visitante) {
            fieldErrors.name = Array.isArray(errorData.nombre_visitante) 
              ? errorData.nombre_visitante[0] 
              : errorData.nombre_visitante;
          }
          if (errorData.telefono_visitante) {
            fieldErrors.phone = Array.isArray(errorData.telefono_visitante) 
              ? errorData.telefono_visitante[0] 
              : errorData.telefono_visitante;
          }
          if (errorData.email_visitante) {
            fieldErrors.email = Array.isArray(errorData.email_visitante) 
              ? errorData.email_visitante[0] 
              : errorData.email_visitante;
          }
          if (errorData.mensaje_inicial) {
            fieldErrors.message = Array.isArray(errorData.mensaje_inicial) 
              ? errorData.mensaje_inicial[0] 
              : errorData.mensaje_inicial;
          }
          if (errorData.fecha_cita) {
            fieldErrors.date = Array.isArray(errorData.fecha_cita) 
              ? errorData.fecha_cita[0] 
              : errorData.fecha_cita;
          }
        } else if (error.response.status === 404) {
          errorMessage = 'La propiedad no fue encontrada';
        } else if (error.response.status >= 500) {
          errorMessage = 'Error del servidor. Por favor intenta nuevamente más tarde';
        } else {
          errorMessage = errorData.message || errorData.detail || errorMessage;
        }
      } else if (error.request) {
        // Network error
        errorMessage = 'Error de conexión. Verifica tu conexión a internet';
      }

      const result = {
        success: false,
        message: errorMessage,
        errors: fieldErrors,
      };

      commit('SET_SUBMISSION_RESULT', result);
      throw result;
    } finally {
      commit('SET_SUBMITTING', false);
    }
  },

  clearSubmissionResult({ commit }) {
    commit('CLEAR_SUBMISSION_RESULT');
  },
};

const getters = {
  isSubmitting: state => state.isSubmitting,
  lastSubmissionResult: state => state.lastSubmissionResult,
  appointments: state => state.appointments,
  appointmentsByProperty: state => propertyId => 
    state.appointments.filter(apt => apt.propertyId === propertyId),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
